import { computed, ref } from 'vue';

import { propsFactory } from '@components/utils';

import { useProxyModel } from './proxyModel';

import type { IDisabledProps } from './disabled';
import type { Ref, PropType, WritableComputedRef } from 'vue';

export interface IMenuProps extends IDisabledProps {
  menu: boolean | undefined;
}
export interface IUseMenu<MenuRef> {
  internalMenu: WritableComputedRef<boolean | undefined>;
  menuRef: Ref<MenuRef | undefined>;
}

export const DEFAULT_MENU_HEIGHT = 178;
export const DEFAULT_MENU_OFFSET = 4;

export const makeMenuProps = propsFactory(
  {
    /**
     * Состояние выпадающего меню (открыто/закрыто)
     */
    menu: {
      type: Boolean as PropType<boolean | undefined>,
      default: undefined
    },
    /**
     * Свойства для компонент CdsMenu
     */
    menuProps: {
      type: Object as PropType<any>,
      default: null
    },
    /**
     * Максимальная высота выпадающего меню (10rem по умолчанию)
     */
    menuHeight: {
      type: [String, Number] as PropType<string | number>,
      default: DEFAULT_MENU_HEIGHT
    }
  },
  'menu'
);

export function useMenu<MenuRef>(props: IMenuProps): IUseMenu<MenuRef> {
  const menuRef = ref<MenuRef | any>();
  const menuModel = useProxyModel(props, 'menu');

  const internalMenu = computed({
    get: () => menuModel.value,
    set: (value) => {
      if ((menuModel.value && !value && menuRef.value?.openChildren) || props.disabled) return;
      menuModel.value = value;
    }
  });

  return { internalMenu, menuRef };
}
